/**
 * O que faz: Exibe rankings de anúncios e links com leads, conversões e taxa.
 * Onde usa: Página de aquisição do DashboardReportDocument.
 * Conexões: DashboardReportModel.
 * Tabelas: Nenhuma; consome agregações já calculadas pelo dashboard.
 * Data: 27/07/2026.
 */

import type { DashboardReportRankingItem } from '@/features/dashboard/report/dashboardReportTypes';
import { ReportSectionCard } from './DashboardReportCharts';

interface DashboardReportRankingsProps {
  title: string;
  subtitle: string;
  data: DashboardReportRankingItem[];
}

export const DashboardReportRankings = ({ title, subtitle, data }: DashboardReportRankingsProps) => {
  const maximum = Math.max(1, ...data.map((item) => item.leads));

  return (
    <ReportSectionCard title={title} subtitle={subtitle}>
      {data.length === 0 ? <div className="rounded-[24px] border border-dashed border-[#C7D8B8] bg-[#F8FBF4] p-10 text-center text-[19px] text-[#6B7B6C]">Nenhum dado identificado neste período.</div> : (
        <div className="space-y-4">
          <div className="grid grid-cols-[44px_1fr_84px_110px_88px] gap-3 border-b border-[#E4ECD9] pb-3 text-[15px] font-bold uppercase tracking-[0.08em] text-[#718070]">
            <span>#</span><span>Origem</span><span className="text-right">Leads</span><span className="text-right">Convertidos</span><span className="text-right">Taxa</span>
          </div>
          {data.map((item, index) => {
            // Normaliza espaços e permite quebra de linha para que nomes longos não pareçam espremidos no PDF.
            const nomeExibicao = item.name.trim().replace(/\s+/g, ' ');
            return (
            <div key={`${item.name}-${index}`} className="grid grid-cols-[44px_1fr_84px_110px_88px] items-center gap-3">
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-[#EAF6D8] text-[16px] font-bold text-[#355F1A]">{index + 1}</span>
              <div className="min-w-0">
                <p className="break-words text-[20px] font-semibold leading-7 tracking-normal text-[#173324]" title={nomeExibicao}>{nomeExibicao}</p>
                <div className="mt-2 h-2 overflow-hidden rounded-full bg-[#EAF0E5]"><div className="h-full rounded-full bg-[#4E8614]" style={{ width: `${(item.leads / maximum) * 100}%` }} /></div>
              </div>
              <strong className="text-right text-[20px] text-[#173324]">{item.leads}</strong>
              <span className="text-right text-[19px] text-[#526255]">{item.conversions}</span>
              <strong className="text-right text-[19px] text-[#355F1A]">{item.conversionRate.toLocaleString('pt-BR')}%</strong>
            </div>
            );
          })}
        </div>
      )}
    </ReportSectionCard>
  );
};
